import styled from 'styled-components';
import { PrimaryButton, PrimaryButtonProps } from 'ia-react-core';
import { FC } from 'react';

export const StyledPrimaryButton = styled<FC<PrimaryButtonProps>>(PrimaryButton)`
  padding-left: 17px;
  padding-right: 17px;
  margin: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue12};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.blue14};
  }
`;
